(function () {
  'use strict';

  var giftSyncInFlight = false;

  function giftConfig() {
    var element = document.querySelector('[data-novo-volume-knob-gift-config]');
    if (!element) return null;
    try { return JSON.parse(element.textContent); } catch (error) { return null; }
  }

  function sectionDescriptors() {
    var source = document.querySelector('cart-drawer-items') || document.querySelector('cart-items');
    return source && source.getSectionsToRender ? source.getSectionsToRender() : [];
  }

  function renderSyncedCart(data, descriptors) {
    descriptors.forEach(function (section) {
      var root = document.getElementById(section.id);
      var html = data.sections && data.sections[section.section || section.id];
      if (!root || !html) return;
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var replacement = parsed.querySelector(section.selector || '.shopify-section');
      var target = root.querySelector(section.selector) || root;
      if (replacement && target) target.innerHTML = replacement.innerHTML;
    });
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      drawer.classList.toggle('is-empty', Number(data.item_count || 0) === 0);
      drawer.syncCartCount && drawer.syncCartCount(Number(data.item_count || 0));
    }
  }

  function syncVolumeKnobGifts(cart) {
    var config = giftConfig();
    if (!config || !config.dashCamVariantId || giftSyncInFlight) return Promise.resolve(cart);
    var required = cart.items.reduce(function (total, item) {
      return total + (/premium/i.test(String(item.variant_title || '').trim()) ? Number(item.quantity || 0) : 0);
    }, 0);
    var giftLines = cart.items.filter(function (item) { return item.properties && item.properties['_Novo VolumeKnob Gift'] === 'Dash cam'; });
    var current = giftLines.reduce(function (total, item) { return total + Number(item.quantity || 0); }, 0);
    if (current === required && giftLines.length <= 1) return Promise.resolve(cart);

    giftSyncInFlight = true;
    var descriptors = sectionDescriptors();
    var sections = Array.from(new Set(descriptors.map(function (section) { return section.section || section.id; })));
    var request;
    if (!giftLines.length && required > 0) {
      request = {url: window.Shopify.routes.root + 'cart/add.js', body: {items: [{id: Number(config.dashCamVariantId), quantity: required, properties: {'_Novo Premium Gift': 'Dash cam', '_Novo VolumeKnob Gift': 'Dash cam'}}]}};
    } else {
      var updates = {};
      giftLines.forEach(function (item, index) { updates[item.key] = index === 0 ? required : 0; });
      request = {url: window.Shopify.routes.root + 'cart/update.js', body: {updates: updates}};
    }
    if (sections.length) {
      request.body.sections = sections;
      request.body.sections_url = window.location.pathname;
    }
    return fetch(request.url, {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify(request.body)})
      .then(function (response) { return response.json().then(function (data) { if (!response.ok) throw new Error(data.description || 'Unable to update the VolumeKnob gift.'); return data; }); })
      .then(function (data) {
        if (Number.isFinite(Number(data.item_count))) return data;
        return fetch(window.Shopify.routes.root + 'cart.js').then(function (response) { return response.json(); }).then(function (cartState) { cartState.sections = data.sections; return cartState; });
      })
      .then(function (data) { renderSyncedCart(data, descriptors); return data; })
      .catch(function (error) { console.warn('Unable to keep the VolumeKnob dash cam gift in sync.', error); return cart; })
      .finally(function () { giftSyncInFlight = false; });
  }

  function fetchAndSyncVolumeKnobGifts() {
    return fetch(window.Shopify.routes.root + 'cart.js').then(function (response) { return response.json(); }).then(syncVolumeKnobGifts).catch(function () {});
  }

  function addUpsell(button) {
    var id = Number(button.dataset.novoCartUpsell);
    var drawer = document.querySelector('cart-drawer');
    button.disabled = true;
    button.textContent = 'Adding…';
    fetch(window.Shopify.routes.root + 'cart.js').then(function (response) { return response.json(); }).then(function (cart) {
      var quantity = cart.items.reduce(function (total, item) { return item.variant_id === id ? total + item.quantity : total; }, 0);
      if (quantity === 1) { if (drawer) drawer.open(); return null; }
      var payload = { items: [{ id: id, quantity: 1 }] };
      if (drawer && drawer.getSectionsToRender) {
        payload.sections = drawer.getSectionsToRender().map(function (section) { return section.id; });
        payload.sections_url = window.location.pathname;
      }
      return fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(payload) }).then(function (response) { return response.json().then(function (data) { if (!response.ok) throw new Error(data.description || 'Unable to add this accessory.'); return data; }); }).then(function (data) { if (drawer) drawer.classList.remove('is-empty'); if (drawer && data.sections) drawer.renderContents(data); else if (drawer) drawer.open(); });
    }).catch(function () {
      button.disabled = false;
      button.textContent = 'Try again';
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-novo-cart-upsell]');
    if (button) addUpsell(button);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fetchAndSyncVolumeKnobGifts, {once: true}); else fetchAndSyncVolumeKnobGifts();
  if (window.subscribe && window.PUB_SUB_EVENTS) window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, fetchAndSyncVolumeKnobGifts);
})();
